/**
 * Activity Color Constants
 * Used for activity creation and editing
 */

export const ACTIVITY_COLORS = [
  { name: "White", value: "#ffffff" },
  { name: "Orange", value: "#ffa600" },
  { name: "Brown", value: "#c26229" },
  { name: "Purple", value: "#813773" },
  { name: "Blue", value: "#276580" },
  { name: "Gray", value: "#444444" },
  { name: "Red", value: "#f44336" },
  { name: "Pink", value: "#e91e63" },
  { name: "Deep Purple", value: "#673ab7" },
  { name: "Indigo", value: "#3f51b5" },
  { name: "Cyan", value: "#00bcd4" },
  { name: "Teal", value: "#009688" },
  { name: "Green", value: "#619c43" },
];

/**
 * Default activity color used when no color is specified
 */
export const DEFAULT_ACTIVITY_COLOR = "#ffffff";
